import PagedList from '../commons/pagedList'
import { adminHttpClient } from '../commons/adminHttpClient'
import { RecurringExpenseFrequency } from '../../domain/expenses/ReccuringExpenseFrequency'
import { RecurringExpenseStatus } from '../../domain/expenses/RecurringExpenseStatus'
import { ProductIds } from 'application/commons/config'

export type RecurringExpenseForReview = {
  recurringExpenseId: string
  companyUser: CompanyUser
  expenseType: ExpenseType
  requestedAmount: number
  frequency: RecurringExpenseFrequency
  startDate: Date
  policyName: string
  expenseNumber: number
  status: RecurringExpenseStatus
  lockedBy?: CompanyUser
  dateSubmitted: string
  resubmitted: boolean
}

type CompanyUser = {
  id: string
  name: string
}

type ExpenseType = {
  id: String
  name: string
}

const getRecurringExpensesForReview = (
  pageNumber: number,
  productId?: ProductIds,
): Promise<PagedList<RecurringExpenseForReview>> => {
  return adminHttpClient.get('/Expenses/RecurringExpensesForReview', {
    pageNumber: pageNumber,
    productId,
  })
}

export default getRecurringExpensesForReview
